/** A request refused while the database recovers: 503, but not the maintenance banner. */
export const SERVICE_OVERLOADED_ERROR = {
  code: 'SERVICE_OVERLOADED',
  message: 'This is taking longer than usual right now. Please try again in a minute.',
} as const
